import {CounterLabel, Details, Heading, Spinner, useDetails} from '@primer/react'
import {Suspense} from 'react'
import {PendingCommentPreview} from '../PendingCommentPreview'
import type {ThreadPreview as PendingCommentPreviewType} from '../../../page-data/payloads/thread-previews'
import {ChevronDownIcon, ChevronRightIcon} from '@primer/octicons-react'

export function ReviewCommentsSection({
  totalPendingComments,
  commentsList,
  handleNavigateToDiffComment,
}: {
  totalPendingComments?: number
  commentsList?: PendingCommentPreviewType[]
  handleNavigateToDiffComment: () => void
}) {
  const {getDetailsProps, open} = useDetails({defaultOpen: true, closeOnOutsideClick: false})

  if (!totalPendingComments) return null

  return (
    <>
      <Details {...getDetailsProps()}>
        <Details.Summary>
          <div className="d-flex flex-row flex-items-center gap-2 tmp-mt-4 mb-2">
            {open && <ChevronDownIcon className="fgColor-muted" />}
            {!open && <ChevronRightIcon className="fgColor-muted" />}
            <Heading as="h2" className="f5">
              Pending comments <CounterLabel>{totalPendingComments}</CounterLabel>
            </Heading>
          </div>
        </Details.Summary>

        <Suspense fallback={<Spinner />}>
          <div className="d-flex flex-column gap-3">
            {commentsList?.map(preview => (
              <PendingCommentPreview
                key={preview.threadId}
                commentPreview={preview}
                onNavigateToDiffComment={handleNavigateToDiffComment}
              />
            ))}
          </div>
        </Suspense>
      </Details>
    </>
  )
}
